import React, { useState, useEffect } from "react";
import styles from "./index.module.css";
import { useIncidents } from "../../../../useIncidents";
import RelatedIncidentsList from "shared/RelatedIncidentsList";
import LoadingPage from "shared/LoadingPage";
import dayjs from "dayjs";

export default function Incidents({ iboNumber }) {
  const { data: incidents, isLoading, refetch } = useIncidents("incidents");

  const [relatedIncidents, setRelatedIncidents] = useState(null);

  useEffect(() => {
    if (incidents) {
      let matchingIncidents = [];
      incidents.forEach((incident) => {
        if (
          incident.complaintAgainst &&
          incident.complaintAgainst.iboNumber &&
          incident.primaryIboNumber
        ) {
          if (
            incident.complaintAgainst.iboNumber.toString() === iboNumber ||
            incident.primaryIboNumber.toString() === iboNumber
          ) {
            matchingIncidents.push(incident);
          }
        }
      });
      setRelatedIncidents(matchingIncidents);
    }
  }, [incidents]);

  return (
    <div className={styles.container}>
      {!isLoading && relatedIncidents ? (
        <RelatedIncidentsList
          incidents={relatedIncidents.map((item) => {
            return {
              number: item.id ? item.id : "N/A",
              status: item.status ? item.status : "N/A",
              type: item.problemType ? item.problemType : "N/A",
              severity: item.severity ? item.severity : "N/A",
              dateCreated: item.createdAt
                ? dayjs(item.createdAt).format("MM/DD/YY")
                : "N/A",
            };
          })}
          onClick={() => {
            setTimeout(() => {
              refetch();
            }, 100);
          }}
        />
      ) : (
        <div className={styles.loadingTab}>
          <LoadingPage />
        </div>
      )}
    </div>
  );
}
